<!-- Echart图 -->
<template>
  <div style="width: 100%;">
    <div style="height: 100%;width: 100%;" body-style="overflow-y: auto;">
      <div class="title">{{content}}</div>
      <div class="echart" ref="echart"></div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive, ref, toRefs, computed } from "vue";
import * as echarts from "echarts";
export default {
  props: {
     content: Object,
     chart: String, 
  },
  components: {},
  setup(props, { emit }) {
    const echart = ref(null);
    const pageConfig = reactive({
      content: props.content,
    });
    let methods = {
      async showEchart() {
        try {
          var chartDom = echart.value;
          chartDom.removeAttribute('_echarts_instance_')
          var myChart = echarts.init(chartDom);
          var option =JSON.parse(props.chart);
          //console.log(option);
          option && myChart.setOption(option); 
        } catch (error) {
          echart.value.innerHTML = "图表解析失败，请检查数据格式是否正确！"+error;
        }
      },
      
  };
    onMounted(() => {
      methods.showEchart();
    });
    return {
      ...toRefs(pageConfig),
      echart,
      methods,
    };
  },
};
</script>
<style lang="scss">
.echart {
    width: 100%;
    height: 100%;
    min-width: 300px;
    min-height: 300px;
}
</style>